import moment from "moment-timezone";
import "moment/dist/locale/en-gb";
import "moment/dist/locale/es";
import "moment/dist/locale/fr";
import { getLocale } from "src/i18n";

const locale = getLocale();
const simpleLocale = locale.includes("fr") ? locale.split("-")[0] : locale.toLowerCase(); // en-gb is handle so we can put it

// Need to be before locale and setDefault
moment.updateLocale("en-gb", {
    longDateFormat: {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY h:mm A",
        LLLL: "dddd, D MMMM YYYY h:mm A",
    },
});

moment.locale(simpleLocale);
moment.tz.setDefault(simpleLocale);
